import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-paginator',
  standalone: false,
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css'],
})

export class PaginatorComponent {
    @Input() pageSize: number;
    @Input() totalItems: number;
    @Input() callback: Function;
    @Input() currentPage: number = 1;
  
    onPageChange(page: number): void {
        const totalPages = this.getTotalPages();
        if (totalPages <= 0) {
            return;
        }
        const nextPage = Math.min(Math.max(page, 1), totalPages);
        if (nextPage === this.currentPage) {
            return;
        }
        this.currentPage = nextPage;
        this.callback(this.pageSize, this.currentPage);
    }

    getPageNumbers(): number[] {
        const totalPages = this.getTotalPages();

        let pageNumbers: number[] = [];

        if(totalPages <= 5){
          return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        if(this.currentPage <= 3){
          pageNumbers = Array.from({ length: 4 }, (_, i) => i + 1);
          pageNumbers.push(totalPages);
          return pageNumbers;
        }

        if(totalPages - this.currentPage <= 2 ){
          pageNumbers =  Array.from({ length: 4 }, (_, i) => totalPages - i);
          pageNumbers.push(1);
          return pageNumbers.sort((a, b) => a - b);
        }

        return [1, this.currentPage -1, this.currentPage, this.currentPage +1 , totalPages];
    }

    getTotalPages(): number {
        return Math.ceil(this.totalItems / this.pageSize);
    }

    onPageSizeChange(){
        this.currentPage = 1;
        this.callback(this.pageSize, this.currentPage);
    }

    hidePagesLeftIcon(page: number){
      return  page == this.getPageNumbers()[1] && page != 2;
    }

    hidePagesRightIcon(page: number){
      const pageNumbers = this.getPageNumbers();
      return page == pageNumbers[pageNumbers.length-2] && page != this.getTotalPages() - 1;
    }
  }